<div class="input-group mbs-advanced-search">
  <div
    ngbDropdown
    class="form-control mbs-advanced-search_form-control row g-0"
    [class.focus]="searchHasFocus"
    [autoClose]="'inside'"
    [placement]="'bottom-left'">
    <div class="col-auto mbs-advanced-search_input">
      <div
        #advancedSearch
        class="mbs-advanced-search_content single-line"
        contenteditable="true"
        placeholder="Enter search request"
        spellcheck="false"
        [id]="'advanced-search'"
        (blur)="handleParseModel()"
        (click)="getCaretPosition($event)"
        (drop)="handleDropEvent($event)"
        (keydown)="handleKeyboardDownEvent($event)"
        (keyup)="handleKeyboardUpEvent($event)"
        (paste)="handlePasteEvent($event)"></div>
      <div
        class="form-control-placeholder mbs-advanced-search_placeholder"
        [class.d-none]="advancedSearch.firstChild">
        {{ placeholder }}
      </div>
    </div>
    <div class="col-auto d-flex align-items-center justify-content-center">
      @if (searching) {
        <div class="px-2">
          <span class="loader"></span>
        </div>
      } @else {
        @if (searchContent.length > 0) {
          <mbs-button
            class="z-3"
            [icon]="'ico ico-Delete-text mr-0 px-2'"
            [isCtrl]="true"
            [title]="'mbs-ui-kit:advanced-search.labels.clear' | i18next"
            [type]="'dark'"
            (click)="handleClear()" />
        }
      }
    </div>

    @if (searchFormTemplate) {
      <div class="col-auto d-flex align-items-center justify-content-center">
        <button
          ngbDropdownToggle
          class="ctrl ctrl-dark px-2"></button>
      </div>
    }

    <div
      ngbDropdownMenu
      #ngbDropdownMenuRef
      class="mbs-advanced-search_dropdown">
      <ng-container [ngTemplateOutlet]="searchFormTemplate" />
    </div>
  </div>

  <div
    aria-labelledby="advanced-search"
    class="dropdown-menu autocomplete-position"
    [class.show]="showDropdown"
    [ngStyle]="dropdownHeight ? { 'overflow-y': 'auto', 'overflow-x': 'hidden', maxHeight: dropdownHeight + 'px' } : null"
    (mouseleave)="selectedItemIndex = -1">
    @for (item of unwrapItems; track item) {
      <button
        class="dropdown-item"
        [class.active]="selectedItemIndex === $index"
        (click)="$event.stopPropagation(); handleClickSelectedValue(item)"
        (mouseenter)="selectedItemIndex = $index">
        <ngb-highlight
          [result]="formatter(item)"
          [term]="getLastWord(advancedSearch.innerText, caret)">
          {{ item }}
        </ngb-highlight>
      </button>
    }
  </div>

  <div class="input-group-append">
    <button
      class="btn btn-secondary"
      (click)="handleEnter($event)">
      <span [ngClass]="searchIcon"></span>
    </button>
  </div>
</div>
